// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__2FxgR","itemA":"Write_itemA__N_vPk","itemB":"Write_itemB__Ez35d","itemC":"Write_itemC__1vaX7","itemD":"Write_itemD__Gn0ZI"};